import { ref } from "vue";

interface User {
  id: string;
  name?: string;
  firstname?: string;
  lastname?: string;
  subs: object;
  created_at: number;
}

const currentUser = ref<User | null>(null);

// Manche Accounts kommen mit unvollstaendigen Stammdaten aus der API.
// Alle drei Felder werden gebraucht: firstname/lastname fuer den GEOcard-Pruefcode, name fuer die Message-Anrede.
export function isAccountComplete(user: User | null | undefined): boolean {
  return !!user?.firstname?.trim() && !!user?.lastname?.trim() && !!user?.name?.trim();
}

export function useCurrentUser() {
  const loadUser = () => {
    const raw = localStorage.getItem("gcU");
    if (raw) {
      try {
        currentUser.value = JSON.parse(raw);
      } catch (e) {
        console.error("Fehler beim Laden des Users:", e);
      }
    }
  };

  const clearUser = () => {
    localStorage.removeItem("gcU");
    currentUser.value = null;
  };

  return {
    currentUser,
    loadUser,
    clearUser,
    isAccountComplete,
  };
}
